"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fino-mornasco": {
    "aa02586e": [{
      "hkey": "d245aaa8",
      "slug": "andrate-valle-mulini",
      "name": "Andrate-Valle Mulini",
      "primary": true,
      "skipSearch": false
    }],
    "andrate": [{
      "hkey": "d245aaa8",
      "slug": "andrate-valle-mulini",
      "name": "Andrate-Valle Mulini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4393276c": [{
      "hkey": "2d871b37",
      "slug": "fino-mornasco",
      "name": "Fino Mornasco",
      "primary": true,
      "skipSearch": false
    }],
    "briccoletta": [{
      "hkey": "2d871b37",
      "slug": "fino-mornasco",
      "name": "Fino Mornasco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f03d571c": [{
      "hkey": "d245aaa8",
      "slug": "andrate-valle-mulini",
      "name": "Andrate-Valle Mulini",
      "primary": true,
      "skipSearch": false
    }],
    "valle-mulini": [{
      "hkey": "d245aaa8",
      "slug": "andrate-valle-mulini",
      "name": "Andrate-Valle Mulini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fino-mornasco"
    }]
  }
};
exports["default"] = _default;